export interface ExerciseLogEntry {
  id: string;
  name: string;
  duration: string;
  calories: string;
  type: string;
  intensity: string;
  date: string;
  loggedAt: string;
}

const STORAGE_KEY = "glucera_exercise_log_history";

function getLocalDateString() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function loadExerciseLogHistory(): ExerciseLogEntry[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function appendExerciseLogEntry(
  entry: Omit<ExerciseLogEntry, "id" | "loggedAt" | "date"> & { date?: string }
): ExerciseLogEntry {
  const full: ExerciseLogEntry = {
    ...entry,
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    date: entry.date ?? getLocalDateString(),
    loggedAt: new Date().toISOString(),
  };
  const history = [full, ...loadExerciseLogHistory()].slice(0, 100);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
  return full;
}

export function getTodayExerciseLogs(date = getLocalDateString()): ExerciseLogEntry[] {
  return loadExerciseLogHistory().filter((e) => e.date === date);
}
